import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-31",
  "use": "icon-button_icon-31-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-button_icon-31\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\" stroke-linecap=\"round\"><path d=\"M17 2h3.325C21.25 2 22 2.748 22 3.672V7h0m0 10v3.301C22 21.24 21.245 22 20.313 22H17h0M7 22H3.657C2.742 22 2 21.26 2 20.349V17h0M2 7V3.64C2 2.736 2.738 2 3.647 2H7M12 7v10M7.5 7v10M16.5 7v10\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol